// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._29bdGujtrlM0eIgD9is_FD{\n    width: 40px;\n    height: auto;\n    position: absolute;\n    top: 0;\n    right: 1rem;\n    font-size: 32px;\n}\n", "",{"version":3,"sources":["PlayControl.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,eAAe;AACnB","file":"PlayControl.css","sourcesContent":[".PlayControl{\n    width: 40px;\n    height: auto;\n    position: absolute;\n    top: 0;\n    right: 1rem;\n    font-size: 32px;\n}\n"]}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"PlayControl": "_29bdGujtrlM0eIgD9is_FD"
};
export default ___CSS_LOADER_EXPORT___;
